module.exports = __webpack_public_path__ + "static/media/nike-green.9c2c3b95.svg";